import actions from './moduleReportsActions.js'

// Section « Rapoarte » (comptable) — lecture seule, rien à garder en state.
export default {
  isRegistered: false,
  namespaced: true,
  state: {},
  mutations: {},
  actions,
  getters: {}
}
